import React from "react";

const Dashboard = (props) => {
  props.history.push(`/general/dashboard`);
  return <></>;
};

export default Dashboard;
